import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import { MeetingService } from 'src/app/core/services/meeting.service';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { SchedulesOnProfileActionsModalComponent } from './schedules-on-profile-actions-modal/schedules-on-profile-actions-modal.component';
declare var bootbox: any;

@Component({
    selector: 'app-schedules-on-profile',
    templateUrl: './schedules-on-profile.component.html',
    styleUrls: ['./schedules-on-profile.component.css']
})
export class SchedulesOnProfileComponent implements OnInit {
    @Input() jobMatchId: any;
    @Input() candidateId: any;
    @Input() feedbackUserIdsList: any;
    @Input() loginRequired: any;
    @Input() externalCommentRequired: any;
    @Input() feedbackType: any;
    @Input() parentScheduleId: any;
    @Input() scheduleId: any;
    @Input() childScheduleId: any;
    @Input() jobMatchObject: any;
    @Input() jobLocation: any;
    @Input() mode: any;
    @Input() displayFeedback: any;
    @Input() allowInterviewSchedule: any;
    @Input() usersToEditFeedback: any;
    @Input() feedbackReadOnly: any;
    @Input() externalMeetingCallId: any;
    @Input() sourceScreen: any;
    @Input() formalizeActivityPayload: any;
    @Output() saveCallback = new EventEmitter<any>();
    @Output() moveToInterviewCallback = new EventEmitter<any>();
    @Output() completeFeedbackCallback = new EventEmitter<any>();

    isLoading: boolean;
    scheduleActions: string[];
    activeFeedbackTab: number;
    scheduleAction: string;
    tabs: any[];
    validTabs: any[];
    steps: any[];
    companyId: any;
    isCorporateFlag: boolean;
    itemType: string;
    jobMatchInfo: any;
    isPhoneScreenFeedbackAvailable: boolean;
    isInterviewFeedbackAvailable: boolean;
    generalFileName: string;
    phoneScreeningFileName: string;
    recruiterScreeningFileName: string;
    interviewFeedbackFileName: string;
    phoneScreenFeedbackUrl: string;
    recruiterScreeningFeedbackUrl: string;
    interviewFeedbackUrl: string;
    isRecruiterScreeningFeedbackAvailable: boolean;
    activeTab: number;
    isSharedRequisition: any;

    constructor(
        private bsModalService: BsModalService,
        private authService: AuthService,
        private jobMatchService: JobMatchService,
        private companyService: CompanyService,
        private meetingService: MeetingService,
        private alertsAndNotificationsService: AlertAndNotificationsService
    ) { }

    ngOnInit(): void {
        this.isLoading = true;
        this.scheduleActions = [
            'Create',
            'Modify',
            'Cancel'
        ];
        this.activeFeedbackTab = 2;
        this.scheduleAction = 'Create';
        this.tabs = [];
        this.validTabs = [];
        this.steps = [];
        this.companyId = this.authService.getUserDetails().company.companyId;
        this.isCorporateFlag = this.companyService.isCorporateCompany();
        this._initializeData(false);
        if (this.feedbackType == 'PhoneScreen') {
            this.itemType = 'phoneScreen';
        } else if (this.feedbackType == 'RecruiterScreening') {
            this.itemType = 'recruiterScreening';
        } else if (this.feedbackType == 'Interview') {
            this.itemType = 'interview';
        }
    }

    // Recruiter Screening's next step isn't always Interview (could be Tech Assessment,
    // Value Assessment, etc.), so it reads the real next step off availableActions'
    // MOVE_FORWARD action instead of the interview-only getMoveToInterviewStepPossibility check.
    _getMoveForwardAction() {
        if (!this.jobMatchInfo || !this.jobMatchInfo.availableActions) {
            return null;
        }
        return this.jobMatchInfo.availableActions.find(action => action.actionType && action.actionType.includes('MOVE_FORWARD')) || null;
    }

    _initializeData(isRefresh) {
        this.isLoading = true;
        this.getCandidateJobMatchCardInfo(() => {
            this.getMoveToInterviewStepPossibility(() => {
                this._checkAvailableFeedbackReports(() => {
                    this._initFileNames();
                    this._loadTabs(isRefresh);
                    this.isLoading = false;
                });
            });
        });
    }

    getCandidateJobMatchCardInfo(successCallback) {
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.jobMatchInfo = data;
            this.jobMatchInfo.interviewNextStep = false;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        }, undefined);
    }

    getMoveToInterviewStepPossibility(successCallback) {
        this.meetingService.getMoveToInterviewStepPossibility(this.scheduleId, (data) => {
            this.jobMatchInfo.interviewNextStep = data.interviewNextStep;
            this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback = data.canMoveCandidateToInterviewAfterCurrentFeedback;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _checkAvailableFeedbackReports(successCallback) {
        this.jobMatchService.getFeedbackReportsAvailability(this.jobMatchId, this.companyId, (data) => {
            let feedbackReports = data.feedbackReportsAvailability;
            this.isPhoneScreenFeedbackAvailable = feedbackReports['phoneScreenFeedbackReport'];
            this.isRecruiterScreeningFeedbackAvailable = feedbackReports['recruiterScreeningFeedbackReport'];
            this.isInterviewFeedbackAvailable = feedbackReports['interviewFeedbackReport'];
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }

    _initFileNames() {
        this.generalFileName = this.jobMatchInfo.name + '-' + this.jobMatchInfo.jobMatchTitle;
        this.phoneScreeningFileName = this.generalFileName + '-PhoneScreen' + '.pdf';
        this.recruiterScreeningFileName = this.generalFileName + '-RecruiterScreening' + '.pdf';
        this.interviewFeedbackFileName = this.generalFileName + '-InterviewFeedback' + '.pdf';
    }

    _loadTabs(isRefresh) {
        this.tabs = [];
        if (this.feedbackType == 'PhoneScreen') {
            this.tabs.push({ name: 'Schedule', step: 'Phone Screen', fileName: '', url: '', isLoading: false });
            if (this.isPhoneScreenFeedbackAvailable) {
                this.phoneScreenFeedbackUrl = 'api/jobmatch/getphonescreenfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                this.tabs.push({ name: 'Completed Feedback', step: 'Phone Screen', fileName: this.phoneScreeningFileName, url: this.phoneScreenFeedbackUrl, isLoading: false });
            }
            this.tabs.push({ name: 'Feedback', step: 'Phone Screen', fileName: '', url: '', isLoading: false, isActive: true });
            if (this.jobMatchInfo.interviewNextStep) {
                if (this.jobMatchInfo.availableActions.filter(action => action.action === 'Move to Interview').length > 0) {
                    this.tabs.push({ name: 'Move to Interview', step: 'Phone Screen', fileName: '', url: '', isLoading: false, isMoveForwardTab: true });
                    if (isRefresh) {
                        this.confirmMoveCandidateToInterview();
                    }
                } else if (this.jobMatchInfo.canMoveCandidateToInterviewAfterCurrentFeedback) {
                    this.tabs.push({ name: 'Move to Interview', step: 'Phone Screen', fileName: '', url: '', isLoading: false, isMoveForwardTab: true, disabled: true, message: 'Move to Interview action is available only if you completed the current Phone Screen feedback.' });
                } else {
                    this.tabs.push({ name: 'Move to Interview', step: 'Phone Screen', fileName: '', url: '', isLoading: false, isMoveForwardTab: true, disabled: true, message: 'Move to Interview action is available only if all the Phone Screen feedback(s) have been completed for this candidate.' });
                }
            }
        } else if (this.feedbackType == 'RecruiterScreening') {
            this.tabs.push({ name: 'Schedule', step: 'Recruiter Screening', fileName: '', url: '', isLoading: false });
            if (this.isRecruiterScreeningFeedbackAvailable) {
                this.recruiterScreeningFeedbackUrl = 'api/jobmatch/getscreeningfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                this.tabs.push({ name: 'Completed Feedback', step: 'Recruiter Screening', fileName: this.recruiterScreeningFileName, url: this.recruiterScreeningFeedbackUrl, isLoading: false });
            }
            this.tabs.push({ name: 'Feedback', step: 'Recruiter Screening', fileName: '', url: '', isLoading: false, isActive: true });
            this._pushMoveForwardTab('Recruiter Screening', isRefresh);
        } else if (this.feedbackType == 'Interview') {
            this.tabs.push({ name: 'Schedule', step: 'Interview', fileName: '', url: '', isLoading: false });
            if (this.allowInterviewSchedule) {
                if (this.isInterviewFeedbackAvailable) {
                    this.interviewFeedbackUrl = 'api/jobmatch/getinterviewfeedbackreport/' + this.jobMatchId + '?companyId=' + this.companyId;
                    this.tabs.push({ name: 'Completed Feedback', step: 'Interview', fileName: this.interviewFeedbackFileName, url: this.interviewFeedbackUrl, isLoading: false });
                }
                this.tabs.push({ name: 'Feedback', step: 'Interview', fileName: '', url: '', isLoading: false, isActive: true });
            } else {
                this.tabs[0].isActive = true;
            }
        }
        this._setActiveTab();
    }

    // Only used for Recruiter Screening: builds the "Move to <next step>" tab generically,
    // since the next step after Recruiter Screening isn't always Interview.
    _pushMoveForwardTab(currentStepLabel, isRefresh) {
        const moveForwardAction = this._getMoveForwardAction();
        if (!moveForwardAction) {
            return;
        }
        if (moveForwardAction.allowed) {
            this.tabs.push({ name: moveForwardAction.action, step: currentStepLabel, fileName: '', url: '', isLoading: false, isMoveForwardTab: true });
            if (isRefresh) {
                this.confirmMoveCandidateToInterview();
            }
        } else {
            // show can be moved after this feedback complete / all feedback(s) completed, per the reason the API gives us
            this.tabs.push({ name: moveForwardAction.action, step: currentStepLabel, fileName: '', url: '', isLoading: false, isMoveForwardTab: true, disabled: true, message: moveForwardAction.message });
        }
    }

    _setActiveTab() {
        this.activeTab = this.tabs.findIndex(tab => tab.isActive == true);
    }

    feedbackSaveCallback() {
        this._initializeData(true);
    }

    feedbackCompleteCallback() {
        if (this.completeFeedbackCallback) {
            this.completeFeedbackCallback.emit();
        }
        this._initializeData(true);
    }

    confirmMoveCandidateToInterview() {
        const moveForwardTab = this.tabs.find(tab => tab.isMoveForwardTab);
        const nextStepLabel = moveForwardTab ? moveForwardTab.name.replace(/^Move to /, '') : 'Interview';
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-info' style='margin-bottom: 0px;'><i class='fas fa-info-circle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: 'Do you want to move the candidate to the ' + nextStepLabel + ' step?',
            className: 'zIndex1060',
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: (result) => {
                if (result) {
                    this.moveCandidateToInterview();
                } else {
                    this.tabs.forEach(tab => {
                        if (tab.isMoveForwardTab) {
                            tab.isActive = true;
                        } else {
                            tab.isActive = false;
                        }
                    });
                    this._setActiveTab();
                }
            }
        });
    }

    moveCandidateToInterview() {
        const moveForwardTab = this.tabs.find(tab => tab.isMoveForwardTab);
        const actionType = moveForwardTab ? moveForwardTab.name : 'Move to Interview';
        const actionLabel = actionType;
        const config = new ModalConfig();
        config.class = 'custom-modal-65';
        config.backdrop = true;
        config.ignoreBackdropClick = true;
        config.keyboard = false;
        config.initialState = {
            actionType: actionType,
            actionLabel: actionLabel,
            jobMatchId: this.jobMatchInfo.jobMatchId,
            candidateId: this.jobMatchInfo.id,
            meetingScheduleId: this.scheduleId,
            externalMeetingCallId: this.externalMeetingCallId,
            sourceScreen: this.sourceScreen,
            formalizeActivityPayload: this.formalizeActivityPayload
        };
        const actionsModal = this.bsModalService.show(SchedulesOnProfileActionsModalComponent, config);

        actionsModal.content.onClose.subscribe((callbackObject: any) => {
            if (callbackObject && callbackObject.callbackType == 'moveCandidate') {
                this.reloadAndMoveToInterviewCallback();
            }
        });
    }

    reloadAndMoveToInterviewCallback() {
        this._initializeData(false);
        if (this.moveToInterviewCallback) {
            this.moveToInterviewCallback.emit();
        }
    }

    _getScheduleLabel() {
        if (this.itemType == 'phoneScreen') {
            return 'Phone Screen';
        } else if (this.itemType == 'recruiterScreening') {
            return 'Recruiter Screening';
        }
        return 'Interview';
    }

    onScheduleCreated() {
        const label = this._getScheduleLabel();
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been scheduled successfully.`, 'success');
    }

    onScheduleModified() {
        const label = this._getScheduleLabel();
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been modified successfully.`, 'success');
    }

    onScheduleCancelled() {
        const label = this._getScheduleLabel();
        this.alertsAndNotificationsService.showBannerMessage(`${label} has been cancelled successfully.`, 'success');
        this._initializeData(false);
    }
}
